<template>
  <div>
    <Header
      title="Add-ons"
      description="From design collaterals to cloud storage and email credits, these optional extras help you tailor your platform to your specific requirments."
    />

    <div class="fixed-top menucontrol-scroll p-8">
      <div class="grid grid-cols-4 gap-4">
        <el-card
          class="elcard-p0px rounded-10px relative"
          v-for="(item, index) in cardsList"
          :key="'item -' + index"
        >
          <img :src="item.img" :alt="item.title" class="w-full addimg-h" />
          <div class="absolute top-0 left-0 py-4 px-8">
            <h6 class="text-white">{{ item.title }}</h6>
          </div>
          <div class="absolute bottom-0 left-0">
            <h2 class="text-white p-6 font-semibold fsize14 lh-26px">
              {{ item.description }}
            </h2>
            <vs-button
              @click="handleClick(item)"
              color="primary"
              class="w-full py-4"
              >{{ item.cta }}</vs-button
            >
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/views/adminPanel/layouts/components/Header";

export default {
  components: {
    Header,
  },
  data() {
    return {
      cardsList: [
        {
          id: "01",
          title: "Digital Creatives",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-admin/add1.png",
          description:
            "Get Design Collaterals that reflect your Brand Identify",
          cta: "Request Collaterals",
          route: "studio",
        },
        {
          id: "02",
          title: "Campaign Credits",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-admin/add3.png",
          description: "Credit Bundles to run your marketing campaign",
          cta: "Get Add-On Bundles",
          route: "campaignAddon",
          params: "Consumable",
        },

        {
          id: "01",
          title: "Cloud Add-Ons",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-admin/add2.png",
          description:
            "Upgrade your platform with Cloud Addons like emails & Cloud Storage",
          cta: "Explore Cloud Add-Ons",
          route: "cloudAddon",
          params: "Renewable",
        },

        {
          id: "01",
          title: "Metaverse Add-Ons",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-admin/Frame%201000002005.png",
          description:
            "Upgrade your platform with Cloud Addons like emails & Cloud Storage",
          cta: "Explore Metaverse",
          route: "Meta",
          params: "Meta",
        },
      ],
    };
  },
  methods: {
    handleClick(item) {
      this.$store.commit("projectFile/SET_ADDON_TYPE", item.params);
      this.$router.push({ name: item.route });
    },
  },
};
</script>
